import { render, staticRenderFns } from "./delivery-speed.vue?vue&type=template&id=78a19a74&scoped=true&"
import script from "./delivery-speed.vue?vue&type=script&lang=js&"
export * from "./delivery-speed.vue?vue&type=script&lang=js&"
import style0 from "./delivery-speed.vue?vue&type=style&index=0&id=78a19a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a19a74",
  null
  
)

export default component.exports